import { Button, Icon, Tabs } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ReactElement } from 'react';
import * as React from 'react';

import { useBreakpointValue } from 'utils/mediaQuery';

import styles from './respondTabs.module.scss';

type PropsT = {
  onChange: (value: string) => void;
  onResize?: (event: React.PointerEvent) => void;
  className: string;
  onTranscriptClick?: () => void;
  transcriptButtonText?: string;
  showSendTranscript: boolean;
  value: string;
  children?: ReactElement;
};

const tabs = [
  {
    id: 'reply',
    label: 'Answer',
    icon: 'reply' as const,
  },
  {
    id: 'note',
    label: 'Internal Note',
    icon: 'sticky-note' as const,
  },
];

export const RespondTabs = (props: PropsT): JSX.Element => {
  const {
    className,
    onChange,
    onResize,
    onTranscriptClick,
    showSendTranscript,
    transcriptButtonText,
    children,
    value,
    ...otherProps
  } = props;

  const rootClass = classnames(styles.container, className);
  const isSmallOrMediumScreen = useBreakpointValue({ base: true, lg: false });

  return (
    <div {...otherProps} className={rootClass} role="tablist">
      <div className={styles.leftWrapper}>
        <Tabs
          tabs={tabs}
          onChange={onChange}
          selectedId={value}
          tabClassName={classnames({
            [styles.tab]: true,
            [styles.tabHideIcon]: isSmallOrMediumScreen,
          })}
        />
      </div>
      <div className={styles.handle} onPointerDown={onResize}>
        <Icon name="bars" className="icon-vertical-fix" />
      </div>
      <div className={styles.rightWrapper}>
        {showSendTranscript && (
          <Button
            onClick={onTranscriptClick}
            className={styles.sendTranscript}
            variant="tertiary"
          >
            {typeof transcriptButtonText === 'string'
              ? transcriptButtonText
              : 'Send transcript'}
          </Button>
        )}
        {children}
      </div>
    </div>
  );
};
